import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  levelList: [],
  levelDetail: [],
  loading: false,
  error: undefined,
};

const levelSlice = createSlice({
  name: "level",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchLevelList(state, action) {
      state.levelList = action.payload;
      state.loading = false;
    },
    fetchLevelDetail(state, action) {
      state.levelDetail = action.payload;
      state.loading = false;
    },
  },
});

export const levelActions = levelSlice.actions;

export default levelSlice.reducer;
